import { lazy } from 'react';

const AgendaLayout         = lazy(() => import('../../agenda/AgendaLayout.jsx'));
const AgendaPage           = lazy(() => import('../../agenda/AgendaPage.jsx'));
const ProfesionalesPage    = lazy(() => import('../../agenda/ProfesionalesPage.jsx'));
const RecursosPage         = lazy(() => import('../../agenda/RecursosPage.jsx'));
const PlantillasPage       = lazy(() => import('../../agenda/PlantillasPage.jsx'));
const HorariosPage         = lazy(() => import('../../agenda/HorariosPage.jsx'));

// Programas — configuración
const ProgramasConfig     = lazy(() => import('../../agenda/ProgramasConfig.jsx'));
const ProgramasConfigForm = lazy(() => import('../../agenda/ProgramasConfigForm.jsx'));

// Programas — venta
const Programas           = lazy(() => import('../../agenda/Programas.jsx'));
const ProgramasForm       = lazy(() => import('../../agenda/ProgramasForm.jsx'));

// Programas — en curso
const ProgramasEnCurso     = lazy(() => import('../../agenda/ProgramasEnCurso.jsx'));
const ProgramasEnCursoForm = lazy(() => import('../../agenda/ProgramasEnCursoForm.jsx'));

const agendaRoutes = [
      {
            path: 'agenda',
            element: <AgendaLayout />,
            children: [
                  { index: true, element: <AgendaPage /> },
                  {
                        path: 'config',
                        children: [
                              { path: 'profesionales', element: <ProfesionalesPage /> },
                              { path: 'recursos',      element: <RecursosPage /> },
                              { path: 'plantillas',    element: <PlantillasPage /> },
                              { path: 'horarios',      element: <HorariosPage /> },
                        ]
                  },
                  {
                        path: 'programas',
                        children: [
                              { index: true,             element: <Programas /> },
                              { path: 'venta/:token',    element: <ProgramasForm /> },
                              { path: 'en-curso',        element: <ProgramasEnCurso /> },
                              { path: 'en-curso/:id',    element: <ProgramasEnCursoForm /> },
                              {
                                    path: 'config',
                                    children: [
                                          { index: true,   element: <ProgramasConfig /> },
                                          { path: 'nuevo', element: <ProgramasConfigForm /> },
                                          { path: ':token', element: <ProgramasConfigForm /> },
                                    ]
                              },
                        ]
                  }
            ]
      }
];

export default agendaRoutes;
